import { useEffect } from "react";

export default function useOutsideAlerter(ref, onClickOutside: () => void) {
	useEffect(() => {
		/**
		 * Alert if clicked on outside of element
		 */
		function handleClickOutside(event: MouseEvent) {
			if (ref.current && !ref.current.contains(event.target)) {
				onClickOutside();
			}
		}

		function handleEnterOutside(event: KeyboardEvent) {
			if (event.key !== "Enter") {
				return;
			}

			if (ref.current && !ref.current.contains(event.target)) {
				onClickOutside();
			}
		}

		// Bind the event listener
		document.addEventListener("mouseup", handleClickOutside);
		document.addEventListener("keypress", handleEnterOutside);
		return () => {
			// Unbind the event listener on clean up
			document.removeEventListener("mouseup", handleClickOutside);
		};
	}, [ref]);
}
